import MosaicsReportListItem from './item.jsx';
import PropTypes from 'prop-types';
import React, {useCallback, useEffect} from 'react';
import {List} from '@mui/material';

export const MosaicsList = props => {
  const {selected, setSelected, onDetailsClick, mosaicPairs} = props;

  const onKeyDown = useCallback(
    event => {
      if (
        (event.keyCode === 40 || event.keyCode === 39) &&
        selected < mosaicPairs.length - 1
      ) {
        setSelected(selected + 1);
        return;
      }
      if ((event.keyCode === 38 || event.keyCode === 37) && selected > 0) {
        setSelected(selected - 1);
        return;
      }
    },
    [mosaicPairs, selected, setSelected],
  );

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown, true);
    return () => {
      window.removeEventListener('keydown', onKeyDown, true);
    };
  }, [onKeyDown]);

  return (
    <List sx={{flex: 1, overflowX: 'hidden', overflowY: 'auto'}}>
      {mosaicPairs.map((pair, index) => {
        const key = `${pair.source.id}:${pair.target.id}`;
        const isSelected = selected === index;
        return (
          <MosaicsReportListItem
            index={index}
            key={key}
            data={pair}
            selected={isSelected}
            onClick={() => setSelected(index)}
            onDetailsClick={details => onDetailsClick(details)}
          />
        );
      })}
    </List>
  );
};

MosaicsList.propTypes = {
  selected: PropTypes.number,
  setSelected: PropTypes.func,
  onDetailsClick: PropTypes.func,
  mosaicPairs: PropTypes.array,
};
